import React, { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { administrationRoutes } from './administration-routes';

export const AdministrationRouter: FC = () => (
    <Routes>
        {administrationRoutes.map((route) =>
            route.index ? (
                <Route key="index" index element={route.element} />
            ) : (
                <Route key={route.path} path={route.path} element={route.element} />
            )
        )}
    </Routes>
);
